export default "__VITE_ASSET__DDe_hTQZ__"